export function toMoney (money = 0) {
    return money.toFixed(2)
}


// WEBPACK FOOTER //
// ./src/filter/moneyFilter.js